import { put } from "redux-saga/effects";
import * as actions from "../actions";
import * as kApi from "../../constants/api";
import axios from "../../axios";
import { Auth } from "aws-amplify";
import { refreshTokenSaga } from "./_LocalRefreshToken";
// import { APP_KEY } from "../../constants/users_login";
import { isFree, isTrial } from "../../helpers/sessionHelpers";

const GetTypeUser = (user, plans) => {
  let tagUser = "";
  if (user.parent_sub) {
    if (parseInt(user.count_patient) > 0) {
      tagUser = "grand";
    } else {
      tagUser = "patient";
    }
  } else {
    if (parseInt(user.count_patient) > 0) {
      tagUser = "parent";
    } else {
      tagUser = "individual";
    }
  }
  let planType = ""
  if (isFree(plans.permissions)) {
    planType = "free";
  } else {
    if (isTrial(plans.plans)) {
      planType = "trial";
    } else {
      planType = "paid";
    }
  }
  return [tagUser + "_" + planType, planType]
};

export function* initSetSessionActiveSaga(action) {
  try {
    const response_user = yield axios.get(kApi.API_Q_USER, {
      headers: {
        Authorization: Auth.user.signInUserSession.idToken.jwtToken,
      },
    });
    let plans = [];
    const plans_user = yield axios.get(kApi.API_URL_PLANS, {
      headers: {
        Authorization: Auth.user.signInUserSession.idToken.jwtToken,
      },
    });
    plans = plans_user.data;
    let isParentPaid = false;
    let isParentActivityStatus =
      response_user.data.parent_activity_status &&
        response_user.data.parent_activity_status === "true"
        ? true
        : null;
    let parentPermission = "";
    if (!!response_user.data.parent_sub) {
      const response = yield axios.get(kApi.API_Q_PARENT_PLANS, {
        headers: {
          Authorization: Auth.user.signInUserSession.idToken.jwtToken,
        },
      });
      if (response.data && response.data["permissions"]) {
        parentPermission = response.data["permissions"];
        isParentPaid = !isFree(response.data["permissions"]);
      }
    }
    const userInfo = response_user.data;
    const userType = GetTypeUser(userInfo, plans_user.data);
    userInfo["typeUser"] = userType[0];
    userInfo["typeProfile"] = userInfo["profile"] + "_" + userType[1];
    userInfo["typePlan"] = userType[1];
    // yield put(actions.setSessionActive(action.session, isParentPaid));
    yield put(
      actions.setSessionActive(
        action.session,
        plans,
        isParentPaid,
        parentPermission,
        isParentActivityStatus,
        userInfo
      )
    );
  } catch (error) {
    try {
      const refreshToken = yield refreshTokenSaga();
      const response_user = yield axios.get(kApi.API_Q_USER, {
        headers: {
          Authorization: refreshToken.signInUserSession.idToken.jwtToken,
        },
      });
      let plans = [];
      const plans_user = yield axios.get(kApi.API_URL_PLANS, {
        headers: {
          Authorization: refreshToken.signInUserSession.idToken.jwtToken,
        },
      });
      plans = plans_user.data;
      let isParentPaid = false;
      let isParentActivityStatus =
        response_user.data.parent_activity_status &&
          response_user.data.parent_activity_status === "true"
          ? true
          : null;
      let parentPermission = "";
      if (!!response_user.data.parent_sub) {
        const response = yield axios.get(kApi.API_Q_PARENT_PLANS, {
          headers: {
            Authorization: refreshToken.signInUserSession.idToken.jwtToken,
          },
        });
        if (response.data && response.data["permissions"]) {
          parentPermission = response.data["permissions"];
          isParentPaid = !isFree(response.data["permissions"]);
        }
      }
      const userInfo = response_user.data;
      const userType = GetTypeUser(userInfo, plans_user.data);
      userInfo["typeUser"] = userType[0];
      userInfo["typeProfile"] = userInfo["profile"] + "_" + userType[1];
      userInfo["typePlan"] = userType[1];
      // yield put(actions.setSessionActive(action.session, isParentPaid));
      yield put(
        actions.setSessionActive(
          action.session,
          plans,
          isParentPaid,
          parentPermission,
          isParentActivityStatus,
          userInfo
        )
      );
    } catch (error) {
      yield put(actions.fetchCodeFail(error));
    }
  }
}
